import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { ProfilePreviewTooltipFragment } from "../profile/ProfilePreviewTooltip/ProfilePreviewTooltip.fragment"

export const ActivityToFragment = graphql(
  `
    fragment ActivityTo on Activity {
      __typename
      to {
        ...AccountLockup
        ...ProfilePreviewTooltip
      }
    }
  `,
  [AccountLockupFragment, ProfilePreviewTooltipFragment],
)
